import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import { Accordion } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import classes from '../../css/item.module.css';
import Tilt from 'react-parallax-tilt';
import { Link } from 'react-router-dom';


const CountComp = (props) => {


    const useItems = props.items;


    return (
        <>
            <div className='sectional-item-container'>
                <div style={{ margin: 'auto', marginBottom: '50px' }} className='home-text-wrapper'>
                    {
                        props.title ?
                            props.title
                            : null
                    }
                    {
                        props.description ?
                            <div className='hero-center'>
                                <p style={{ maxWidth: '477px', color: 'white' }}>{props.description}</p>
                            </div>
                            : null
                    }




                </div>

                <div className='user-items'>

                    <ol>
                        {useItems.filter((item, index) => index < 6).map((item) => {
                            return (
                                <li>
                                    <h4><span>{useItems.indexOf(item) + 1}</span>{item.value}</h4>
                                    <p>{item.description}</p>
                                    {item.link ? <Link to={item.link}>
                                        {item.linkTitle}
                                    </Link> : null}
                                </li>
                            )
                        })}
                    </ol>
                </div>

            </div>


        </>
    );
};

export default CountComp;
